/**
* 纠纷详情
*/
<template>
    <div  class="box-style">
        <van-nav-bar placeholder title="纠纷详情" left-text="" left-arrow @click-left="onClickLeft()">
            <template #right>
            </template>
        </van-nav-bar>

      <van-pull-refresh v-model="loading" @refresh="refresh()" style="min-height: 100vh">
        <div class="yj-box">
          <div class="box-title">
            <h2>纠纷内容</h2>
            <!--<img src="~@/assets/xl.png">-->
          </div>
          <div class="yj-con">
            <div class="con-list"><span>申请时间：</span><p>{{ record.applyTime }}</p></div>
            <div class="con-list"><span>申请方：</span><p>{{ filterLabelName(applySideOption, record.applySide) }}</p></div>
            <div class="con-list"><span>申请人：</span><p>{{ record.applyUserName }}</p></div>
            <div class="con-list"><span>联系方式：</span><p>{{ record.mobileNum }}</p></div>
            <div class="con-list"><span>纠纷类型：</span><p>{{ filterLabelName(disputeTypeOption, record.disputeType) }}</p></div>
            <div class="con-list"><span>课程名称：</span><p>{{ record.curriculumName }}</p></div>
            <div class="con-list"><span>销课日期：</span><p>{{ record.signTime }}</p></div>
            <div class="con-list"><span>图片：</span><p><custom-upload ref="picUrls" :showUpload="false" :value="record.picUrls"/></p></div>
            <div class="con-list"><span>视频：</span><p><video-upload ref="picUrls" :showUpload="false" :value="record.videoUrls"/></p></div>
            <div class="con-list"><span>纠纷内容：</span><p>{{ record.disputeDes }}</p></div>
          </div>
        </div>
        <div  class="yj-box">
          <div  class="box-title">
            <h2>调处结果</h2>
            <!--<img src="~@/assets/xl.png">-->
          </div>
          <div class="yj-con">
            <div class="con-list"><span>调处结果：</span><p>{{ filterLabelName(mediateResultList, record.mediateResult) }}</p></div>
            <div class="con-list"><span>图片：</span><p><custom-upload ref="mediateUrls" :showUpload="false" :value="record.mediateUrls"/></p></div>
            <div class="con-list"><span>调处说明：</span><p>{{ record.mediateDes }}</p></div>
          </div>
        </div>
      </van-pull-refresh>

    </div>
</template>

<script>

    import {get} from '@/api/dispute/disputeInfo'
    import {getDictByType,filterLabelName, conversionDict} from '@/api/common'
    import customUpload from '@/components/customUpload'
    import videoUpload from '@/components/videoUpload'

    export default {
        name: 'DisputeDetail',
        components: {customUpload, videoUpload},
        data () {
            return {
                loading: false,
                activeNames: ['1'],
                filterLabelName,
                applySideOption: [],
                mediateResultList: [],
                statusOption: [{ label: '待调处', value: '0' }, { label: '已调处', value: '1' }],
                disputeTypeOption: [{ label: "销课争议", value: '1' }, { label: "退费争议", value: '2' }, { label: "其他", value: '3' }],
                id: '',
                record: {}
            }
        },
        computed: {
        },
        created () {
            this.id = this.$route.query.id;
            this.refresh()
        },
        mounted () {
        },
        methods: {
            getDict(){
                // 发起方
                getDictByType('apply_side_type').then(res => {
                    this.applySideOption = conversionDict(res)
                });
                // 调解结果状态
                getDictByType('mediate_result').then(res => {
                    this.mediateResultList = conversionDict(res)
                });
                // 机构类型
                getDictByType('institution_type').then(res => {
                    this.institutionTypeOption = conversionDict(res)
                })
            },
            refresh() {
                this.getDict()
                this.getDetail()
            },
            onClickLeft() {
                this.$router.go(-1)
            },
            getDetail() {
                get(this.id).then(res => {
                    if (res.code === 10000) {
                        this.record = res.result
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                })
            },
        }
    }
</script>

<style scoped>
.yj-box{
  display: flex;
  margin: 0 10px;
  flex-direction: column;
}
.box-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height:16px;
  margin-top: 23px;
  margin-bottom: 17px;
}
.box-title h2{
  display: flex;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.box-title img{
  width: 16px;
  height: 9px;
}
.yj-con{
  background: #F4F5F7;
  border-radius:12px;
  display: flex;
  padding: 17px;
  flex-direction: column;
}
.con-list{
  display: flex;
  margin-bottom: 15px;
}
.con-list:last-child{
  margin-bottom: 0;
}
.con-list span{
  display: flex;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  width:75px;
  justify-content: flex-end;
  padding-right: 5px;
}
.con-list p{
  display: flex;
  flex: 1;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
/deep/.van-uploader__preview-image{
  height: 15vw;
  width:73px;
}
.box-style{
  padding-bottom: 20px;
}
</style>
